module.exports = __webpack_public_path__ + "static/media/tyre-yellow-three1.643e83f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tyre-yellow-three1.png
// module id = 350
// module chunks = 0